import React from 'react'
import FAQ from './components/FAQ'

const Frequently = () => {
  return (
    <div>
      <FAQ/>
    </div>
  )
}

export default Frequently
